import { NavLink, Navigate, Outlet, Link } from "react-router-dom";
import { LayoutDashboard, Briefcase, MessageSquare, CalendarClock, User, MapPin, LogOut } from "lucide-react";
import { usePriest } from "../lib/auth";

const TABS = [
  { to: "/priest", label: "Dashboard", icon: LayoutDashboard, end: true },
  { to: "/priest/requests", label: "Requests", icon: Briefcase },
  { to: "/priest/messages", label: "Messages", icon: MessageSquare },
  { to: "/priest/availability", label: "Availability", icon: CalendarClock },
  { to: "/priest/profile", label: "Profile", icon: User },
];

export default function PriestLayout() {
  const { user, ready, logout } = usePriest();
  if (!ready) return <div className="grid min-h-screen place-items-center bg-[#FAFAF5] text-[#7A1523]">Loading…</div>;
  if (!user) return <Navigate to="/priest/login" replace />;
  const initial = (user?.name || user?.email || "P")[0]?.toUpperCase();

  return (
    <div className="pc-grain min-h-screen bg-[#FAFAF5] font-body text-[#2B1B17]">
      <header className="sticky top-0 z-40 border-b border-[#EEE3D6] bg-white/85 backdrop-blur-xl">
        <div className="mx-auto flex max-w-7xl items-center justify-between gap-4 px-4 py-3 sm:px-6 lg:px-8">
          <Link to="/priest" className="flex items-center gap-2.5">
            <span className="grid h-9 w-9 place-items-center rounded-xl bg-[#7A1523] font-heading text-lg text-white">ॐ</span>
            <div className="leading-tight">
              <span className="block font-heading text-lg text-[#7A1523]">PurohithConnect™</span>
              <span className="hidden text-[10px] font-semibold uppercase tracking-wide text-[#A0968A] sm:block">Purohith workspace</span>
            </div>
          </Link>
          <div className="flex items-center gap-3">
            <span className="hidden items-center gap-1.5 rounded-full border border-[#EAD9C4] bg-white/70 px-3 py-1.5 text-xs font-semibold text-[#7A1523] sm:flex">
              <MapPin size={13} /> Rajajinagar
            </span>
            <span className="grid h-9 w-9 place-items-center rounded-full bg-[#7A1523] font-heading text-sm text-white ring-2 ring-white">{initial}</span>
            <button onClick={logout} data-testid="priest-logout" className="flex items-center gap-1 rounded-full border border-[#E7C9CD] px-3 py-1.5 text-xs font-semibold text-[#7A1523] transition hover:bg-[#F4E4E6]">
              <LogOut size={13} /> Exit
            </button>
          </div>
        </div>
        <nav className="mx-auto flex max-w-7xl gap-1 overflow-x-auto px-3 pb-1 sm:px-6 lg:px-8">
          {TABS.map(({ to, label, icon: Icon, end }) => (
            <NavLink key={to} to={to} end={end} data-testid={`priest-tab-${label.toLowerCase()}`}
              className={({ isActive }) => `flex shrink-0 items-center gap-1.5 border-b-2 px-3 py-2.5 text-sm font-semibold transition-colors ${isActive ? "border-[#7A1523] text-[#7A1523]" : "border-transparent text-[#7A6E64] hover:text-[#2B1B17]"}`}>
              <Icon size={16} /> {label}
            </NavLink>
          ))}
        </nav>
      </header>
      <main className="mx-auto max-w-7xl px-4 py-6 sm:px-6 lg:px-8 pc-fade-in"><Outlet /></main>
    </div>
  );
}
